import store from '../store'
import {apolloClient as apollo} from '@/graphql/apollo'

export const apolloClient = {
  async query (input) {
    store.dispatch('resetAllMessages');
    return await apollo.query(input)
  },
  async mutate (input) {
    store.dispatch('resetAllMessages');
    return await apollo.mutate(input)
  },
};

export const apolloSilent = {
  async query (input) {
    return apollo.query(input);
  },
  async mutate (input) {
    return apollo.mutate(input);
  },
};




// WEBPACK FOOTER //
// ./src/graphql/apolloWrapper.js